'use client';

import PreviousButtonCommon from './previous-button-common';

const PreviousButtonMobile = () => {
  return (
    <PreviousButtonCommon
      className="size-8 shrink-0 bg-primary-50 text-black hover:bg-primary-100"
      arrowClassName="size-3"
    />
  );
};

export default PreviousButtonMobile;
